
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyBZU73rndiyE_NEJxjyijdDeX8_s3qAk1I",
    authDomain: "firstwebsite-eb500.firebaseapp.com",
    projectId: "firstwebsite-eb500",
    storageBucket: "firstwebsite-eb500.firebasestorage.app",
    messagingSenderId: "340684398155",
    appId: "1:340684398155:web:82644f75f94ddcb42937ce",
    measurementId: "G-7K7HM9K8VV",
    databaseURL: "https://firstwebsite-eb500-default-rtdb.firebaseio.com/",
  };

// Initialisation de Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);
export const storage = getStorage(app); // Ajoutez cette ligne

export { auth, database };


/*

const { Client } = require('ssh2');
const { Client: PgClient } = require('pg');
const net = require('net');

async function testSSHDatabase() {
  const ssh = new Client();
  
  return new Promise((resolve, reject) => {
    ssh.on('ready', () => {
      console.log('✅ SSH connected!');
      
      const server = net.createServer((clientSocket) => {
        ssh.forwardOut('127.0.0.1', 0, '127.0.0.1', 5432, (err, serverSocket) => {
          if (err) {
            console.error('❌ SSH forward error:', err.message);
            clientSocket.end();
            return;
          }
          clientSocket.pipe(serverSocket).pipe(clientSocket);
        });
      });
      
      server.listen(0, '127.0.0.1', async () => {
        const localPort = server.address().port;
        console.log(`✅ Local tunnel on port ${localPort}`);
        
        const pgClient = new PgClient({
          host: '127.0.0.1',
          port: localPort,
          user: '',
          password: '',
          database: 'htt'
        });
        
        try {
          await pgClient.connect();
          console.log('✅ PostgreSQL connected!');
          
          // Check existing tables
          const tables = await pgClient.query(`
            SELECT table_name FROM information_schema.tables 
            WHERE table_schema = 'public' 
            ORDER BY table_name;
          `);
          console.log('✅ Existing tables:', tables.rows.map(r => r.table_name));
          
          // Create our test table with unique name
          await pgClient.query(`
            CREATE TABLE IF NOT EXISTS connection_test (
              id SERIAL PRIMARY KEY,
              test_message TEXT,
              created_at TIMESTAMP DEFAULT NOW()
            )
          `);
          console.log('✅ Test table created!');
          
          // Insert test data
          await pgClient.query("INSERT INTO connection_test (test_message) VALUES ('SSH connection successful!')");
          console.log('✅ Data inserted!');
          
          // Read test data
          const result = await pgClient.query('SELECT * FROM connection_test ORDER BY created_at DESC LIMIT 1');
          console.log('✅ Latest record:', result.rows[0]);
          
          await pgClient.end();
          server.close();
          ssh.end();
          resolve(true);
          
        } catch (dbErr) {
          console.error('❌ Database error:', dbErr.message);
          server.close();
          ssh.end();
          reject(dbErr);
        }
      });
    });
    
    ssh.on('error', (err) => {
      console.error('❌ SSH error:', err.message);
      reject(err);
    });
    
    console.log('🔄 Connecting to SSH...');
    ssh.connect({
      host: '82.25.116.182',
      username: '',
      password: '',
      port: 22
    });
  });
}

testSSHDatabase()
  .then(() => console.log('\n🎉 SSH + Database connection works perfectly!'))
  .catch((err) => console.error('\n💥 Failed:', err.message));
*/